import { defineComponent as _defineComponent } from 'vue'
import { computed, onBeforeMount, onBeforeUnmount, ref, watch } from "vue"
import { TabsProviderKey, AddTabKey, UpdateTabKey, DeleteTabKey } from "./symbols"
import { injectStrict } from "./utils"

type ClassPropShape = string | Record<string, boolean> | Array<string | Record<string, boolean>>

type Props = {
  panelClass?: ClassPropShape
  id?: string
  name: string
  prefix?: string
  suffix?: string
  isDisabled?: boolean
  navItemClass?: ClassPropShape
  navItemLinkClass?: ClassPropShape
}


export default /*@__PURE__*/_defineComponent({
  __name: 'AppTab',
  props: {
    panelClass: { default: "tabs-component__panel" },
    id: { default: undefined },
    name: {},
    prefix: { default: "" },
    suffix: { default: "" },
    isDisabled: { type: Boolean, default: false },
    navItemClass: { default: undefined },
    navItemLinkClass: { default: undefined }
  },
  setup(__props: any, { expose: __expose }) {

const props = __props

const isActive = ref(false)

const tabsProvider = injectStrict(TabsProviderKey)
const addTab = injectStrict(AddTabKey)
const updateTab = injectStrict(UpdateTabKey)
const deleteTab = injectStrict(DeleteTabKey)

const header = props.prefix + props.name + props.suffix
const computedId = props.id
  ? props.id
  : props.name.toLowerCase().replace(/ /g, "-")
const panelId = computedId + "-panel"
const hash = computed(() => "#" + (!props.isDisabled ? computedId : ""))

watch(
  () => tabsProvider.activeTabHash,
  () => {
    isActive.value = hash.value === tabsProvider.activeTabHash
  }
)

watch(
  () => Object.assign({}, props),
  () => {
    updateTab(computedId, {
      name: props.name,
      header: props.prefix + props.name + props.suffix,
      isDisabled: props.isDisabled,
      hash: hash.value,
      index: tabsProvider.tabs.length,
      computedId: computedId,
      panelId: panelId,
      navItemClass: props.navItemClass,
      navItemLinkClass: props.navItemLinkClass
    })
  }
)

onBeforeMount(() => {
  addTab({
    name: props.name,
    header: header,
    isDisabled: props.isDisabled,
    hash: hash.value,
    index: tabsProvider.tabs.length,
    computedId: computedId,
    panelId: panelId,
    navItemClass: props.navItemClass,
    navItemLinkClass: props.navItemLinkClass
  })
})

onBeforeUnmount(() => {
  deleteTab(computedId)
})

__expose({
  header,
  computedId,
  panelId,
  hash,
  isActive
})

const __returned__ = { props, isActive, tabsProvider, addTab, updateTab, deleteTab, header, computedId, panelId, hash, computed, onBeforeMount, onBeforeUnmount, ref, watch, get TabsProviderKey() { return TabsProviderKey }, get AddTabKey() { return AddTabKey }, get UpdateTabKey() { return UpdateTabKey }, get DeleteTabKey() { return DeleteTabKey }, get injectStrict() { return injectStrict } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})